/**
 * abibelle-review-config.js
 * Configuration centralisée du système d'avis Abibelle.
 * Modifier uniquement ce fichier pour ajuster le comportement global.
 *
 * Important : aucune décision esthétique ne doit être prise dans les routes Vercel.
 * Toute modification de l'ordre, de la disposition ou du design des avis doit pouvoir
 * être réalisée uniquement dans les fichiers du thème Shopify (.liquid et .css),
 * sans modifier le backend.
 */

window.AbibelleReviewConfig = {

  /* URL du backend Vercel — modifier ici si le domaine change */
  apiBase: 'https://abibelle-review.vercel.app',

  /* Nombre d'avis affichés par tranche (bouton "Afficher plus") */
  perPage: 5,

  /* Décalage en pixels pour le scroll vers la liste (hauteur du sticky header) */
  scrollOffset: 80,

};
